import TomSelect from 'tom-select';

{
    function init(selectElem) {
        let settings = JSON.parse(selectElem.nextElementSibling.textContent);
        settings = {
            ...settings,
            ...getRenderSettings(settings),
            ...(settings.django_url ? getRemoteLoadingSettings(settings) : {}),
        };
        if (settings.extraSettingsCallback && typeof window[settings.extraSettingsCallback] === 'function') {
            settings = window[settings.extraSettingsCallback](settings);
        }

        // eslint-disable-next-line no-new
        new TomSelect(selectElem, settings);
    }

    function initMany(rootElem) {
        rootElem = rootElem || document;
        rootElem.querySelectorAll('select.tom-select-widget').forEach((selectElem) => {
            if (selectElem.tomselect) return;
            init(selectElem);
        });
    }

    function getRemoteLoadingSettings(settings) {
        return {
            firstUrl: function(query) {
                return settings.django_url + '?q=' + encodeURIComponent(query);
            },
            load: function(query, callback) {
                // retrieve the appropriate url
                const url = this.getUrl(query);
                // const url = tomSelectSettings.django_url + "?q=" + encodeURIComponent(query);

                fetch(url)
                    .then((response) => response.json())
                    .then((json) => {
                        if (json.has_more) {
                            this.setNextUrl(query, url + '&p=' + (json.page + 1));
                        }
                        // // Workaround for an issue of the virtual scroll plugin
                        // // where it    scrolls to the top of the results whenever
                        // // a new page of results is added.
                        // // https://github.com/orchidjs/tom-select/issues/556
                        // const _scrollToOption = this.scrollToOption;
                        // this.scrollToOption = () => {};
                        callback(json.results);
                        // this.scrollToOption = _scrollToOption;
                    })
                    .catch(() => {
                        callback();
                    });
            },
        };
    }

    function getRenderSettings(settings) {
        const renderSettings = {};
        for (const [name, funcStr] of Object.entries(settings.render || {})) {
            // eslint-disable-next-line no-eval
            renderSettings[name] = eval(funcStr);
        }
        return { render: renderSettings };
    }

    document.addEventListener('DOMContentLoaded', () => initMany());

    window.tomSelectWidget = {
        init: initMany,
    };
}
